import { render, staticRenderFns } from "./AvatarPreviewer.vue?vue&type=template&id=b33a7634&scoped=true&"
import script from "./AvatarPreviewer.vue?vue&type=script&lang=js&"
export * from "./AvatarPreviewer.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPreviewer.vue?vue&type=style&index=0&id=b33a7634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33a7634",
  null
  
)

export default component.exports